function setCacheHas(a){return this.__data__.has(a)}module.exports=setCacheHas;